(() => {
    HuiNavHeadController.$inject = ['$scope', '$element', '$timeout'];

    function HuiNavHeadController($scope, $element, $timeout) {
        const self = this;

        self.$onChanges = (changeObj) => {
            if (changeObj.showInput?.previousValue !== changeObj.showInput?.currentValue) {
                if (self.showInput) {
                    $timeout(() => {
                        $element?.find('input').focus();
                    });
                }
            }
        }
    }

    angular
        .module("harriApp")
        .directive("huiNavHead", function () {
            return {
                restrict: 'E',
                replace: true,
                scope: true,
                bindToController: {
                    label: '<',
                    showInput: '<',
                    searchEnabled: '<',
                    onToggleSearch: '&',
                    onFilterItems: '&',
                    searchTerm: '=',
                    showBackArrow: '<',
                    onBackArrowClick: '&',
                    open: '<',
                    icon: '<',
                },
                controllerAs: '$ctrl',
                controller: HuiNavHeadController,
                templateUrl: `../hmodules/harri-main/ui-components/hui-nav-head.html`
            }
        });

})();